import React, { useState, useEffect, useRef } from 'react';
import { Close } from '@mui/icons-material';
import axios from 'axios';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import {
    Modal,
    Box,
    Button,
    Typography,
    Grid,
    Snackbar,
    Alert,
    TextField
} from '@mui/material';
import ApiService from '../service/ApiService';


const ClienteEditModal = ({ open, onClose, selectedRMA, handleSave }) => {
    const [datiRMA, setDatiRMA] = useState(selectedRMA);
    const [isModified, setIsModified] = useState(false);
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const idCliente = user?.id;
    const headers = {
        Authorization: `Bearer ${token}`
    };

    const { t } = useTranslation();
    const modalRef = useRef(null);

    useEffect(() => {
        if (open && modalRef.current) {
            modalRef.current.scrollTop = 0;
        }
    }, [open]);

    const formatData = (data) => {
        return dayjs(data).format('DD/MM/YYYY');
    };

    const handleSaveModifiche = () => {
        const idReso = selectedRMA?.idReso;
        const destinatario = selectedRMA?.cliente?.emailPersonaContatto;
        const idDestinatario = selectedRMA?.cliente?.id;

        const messaggioDefault = `Aggiornamento Stato Reso #${idReso}`;

//aggiungere le mail!!!!!

        handleSubmit();
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const handleSubmit = async () => {
        try {
            const formattedFormData = {
                ...datiRMA,
                dataFattura: datiRMA?.dataFattura ? formatData(datiRMA.dataFattura) : null,
                dataRicezioneMerce: datiRMA?.dataRicezioneMerce ? formatData(datiRMA.dataRicezioneMerce) : null,
                richiestaIntegrazione: false

            };
            delete formattedFormData.files;

            const response = await axios.post(`/rma/salva/${idCliente}`, formattedFormData, { headers: headers });
            // const response = await ApiService.request("rmaClienteSave", {idCliente: idCliente}, formattedFormData);
            handleSave(formattedFormData);
        } catch (error) {
            setAlert({ open: true, message: "Errore durante il salvataggio del reso.", severity: 'error' });
            setTimeout(() => setAlert({ ...alert, open: false }), 6000);
        }

        onClose();
    };

    const handleInputChange = (field, value) => {
        if (['imeiSerial', 'quantita', 'descrizione'].includes(field)) {
            setDatiRMA((prevState) => ({
                ...prevState,
                prodotti: [
                    {
                        ...prevState.prodotti?.[0],
                        [field]: value,
                    },
                ],
            }));
        } else {
            setDatiRMA((prevState) => ({
                ...prevState,
                [field]: value,
            }));
        }
        setIsModified(true);
    };

    return (
            <Box
                className="modal-container"
                sx={{
                    px: 4,
                    backgroundColor: 'white',
                    borderRadius: 2,
                    margin: 'auto',
                    overflowY: 'auto',
                }}
            >
                <Modal open={open} onClose={onClose}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Box sx={{
                        px: 4,
                        backgroundColor: 'white',
                        borderRadius: 2,
                        maxWidth: '85%',
                        maxHeight: '95%',
                        margin: 'auto',
                        overflowY: 'auto',
                        border: 'solid 2px #bdbdbd',
                        width: '90vw',
                    }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="h6" fontSize={25} my={3} sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                                {t('Modifica Reso')}
                            </Typography>
                            <Button onClick={onClose}
                                sx={{
                                    position: 'relative',
                                    top: 0,
                                    right: 0,
                                    bgcolor: 'white'
                                }}>
                                <Close sx={{
                                    color: '#CCCCCC',
                                    '&:hover': {
                                        color: 'red',
                                    }
                                }} />
                            </Button>
                        </Box>
                        <Box>
                            <Grid container spacing={2}>
                                
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={t('IMEI o SERIAL NUMBER')}
                                        value={datiRMA?.prodotti?.[0]?.imeiSerial || ''}
                                        onChange={(e) => handleInputChange('imeiSerial', e.target.value)}
                                        fullWidth
                                        inputProps={{ maxLength: 20 }}
                                        sx={{
                                            width: "100%",
                                            textAlign: "left",
                                            borderRadius: "10px",
                                            backgroundColor: "#FFFFFF",
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                borderColor: "#fda03d",
                                                },
                                            "&.Mui-focused fieldset": {
                                                    borderColor: "#fda03d",
                                                },
                                            },
                                            
                                            "& .MuiInputLabel-root.Mui-focused": {
                                                color: "#fda03d",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label={t('Quantità')}
                                        type="number"
                                        value={datiRMA?.prodotti?.[0]?.quantita || ''}
                                        onChange={(e) => handleInputChange('quantita', e.target.value)}
                                        fullWidth
                                        sx={{
                                            width: "100%",
                                            textAlign: "left",
                                            borderRadius: "10px",
                                            backgroundColor: "#FFFFFF",
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                borderColor: "#fda03d",
                                                },
                                            "&.Mui-focused fieldset": {
                                                    borderColor: "#fda03d",
                                                },
                                            },
                                            
                                            "& .MuiInputLabel-root.Mui-focused": {
                                                color: "#fda03d",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t('Descrizione del problema riscontrato')}
                                        value={datiRMA?.descrizioneProblema || ''}
                                        onChange={(e) => handleInputChange('descrizioneProblema', e.target.value)}
                                        fullWidth
                                        multiline
                                        rows={4}
                                        sx={{
                                            width: "100%",
                                            textAlign: "left",
                                            borderRadius: "10px",
                                            backgroundColor: "#FFFFFF",
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                borderColor: "#fda03d",
                                                },
                                            "&.Mui-focused fieldset": {
                                                    borderColor: "#fda03d",
                                                },
                                            },
                                            
                                            "& .MuiInputLabel-root.Mui-focused": {
                                                color: "#fda03d",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={t('Descrizione del prodotto')}
                                        value={datiRMA?.prodotti?.[0]?.descrizione || ''}
                                        onChange={(e) => handleInputChange('descrizione', e.target.value)}
                                        fullWidth
                                        multiline
                                        rows={4}
                                        sx={{
                                            width: "100%",
                                            textAlign: "left",
                                            borderRadius: "10px",
                                            backgroundColor: "#FFFFFF",
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                borderColor: "#fda03d",
                                                },
                                            "&.Mui-focused fieldset": {
                                                    borderColor: "#fda03d",
                                                },
                                            },
                                            
                                            "& .MuiInputLabel-root.Mui-focused": {
                                                color: "#fda03d",
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Box sx={{ textAlign: 'right' }}>
                                <Button variant="contained"
                                    sx={{
                                        borderRadius: '10px',
                                        width: '10em',
                                        backgroundColor: "#213d72",
                                        color: "#ffffff",
                                        mt: 2,
                                        mb: 2,
                                        "&:hover": {
                                            backgroundColor: "#1a315b",
                                            transform: "scale(1.05)",
                                        },
                                    }}
                                    autoFocus
                                    onClick={handleSaveModifiche}>{t('Salva')}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>

                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                        {message}
                    </Alert>
                </Snackbar>
            </Box>
    );
};

export default ClienteEditModal;
